function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { __rest } from '../../../../../../_virtual/_tslib.js';
import '@helix/helix-icon/outlined';
import React, { useState, useRef, useEffect } from 'react';
import '@helix/helix-icon';
import NavbarBadge from './NavbarBadge.js';
import { checkIfChildIsA, getTarget } from './NavbarHelpers.js';
import { NavbarHelixIcon } from './NavbarHelixIcon.js';

var NavbarMenuItem = function NavbarMenuItem(_a) {
  var menuItem = _a.menuItem,
      highlightedIndex = _a.highlightedIndex,
      index = _a.index,
      location = _a.location,
      getItemProps = _a.getItemProps,
      itemFormatter = _a.itemFormatter,
      linkWrapper = _a.linkWrapper,
      className = _a.className,
      rest = __rest(_a, ["menuItem", "highlightedIndex", "index", "location", "getItemProps", "itemFormatter", "linkWrapper", "className"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var menuRef = useRef(null);
  var useCheckmarkActive = false;
  var activeCheckmark = null;

  var formatMenuItem = function formatMenuItem() {
    return itemFormatter ? itemFormatter(menuItem) : menuItem.label;
  };

  var itemContent = function itemContent(menuItem) {
    return React.createElement(React.Fragment, null, React.createElement("span", {
      className: 'dropdown-menu-item-content'
    }, React.createElement("span", null, menuItem.label, menuItem.badge && menuItem.badge.label !== undefined && !menuItem.badge.hidden && React.createElement(NavbarBadge, null, menuItem.badge.label)), activeCheckmark));
  };

  var renderDropdownItem = function renderDropdownItem(dropdownItem, dropdownIndex) {
    var isChild = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var _a, _b, _c, _d, _e, _f, _g, _h;

    return React.createElement("li", Object.assign({
      key: dropdownIndex,
      className: "\n                ".concat(dropdownIndex === highlightedIndex ? 'highlighted' : '', "\n                ").concat(dropdownItem.active && !useCheckmarkActive ? 'active' : '', " \n                ").concat(dropdownItem.divider ? 'divider' : '', " \n                ").concat(dropdownItem.header ? 'section-header section-header-bold' : '', " \n                ").concat(isChild ? 'helix-dropdown-menu__sub-menu-item' : '', "\n                ").concat(dropdownItem.disabled ? ' disabled' : '', " \n                ").concat(isChild && !isOpen ? 'helix-dropdown-menu__sub-menu-item--closed' : '', "\n                ").concat(dropdownItem.url && dropdownItem.url === (location === null || location === void 0 ? void 0 : location.pathname) || dropdownItem.active || dropdownItem.activePathname && dropdownItem.activePathname === (location === null || location === void 0 ? void 0 : location.pathname) ? 'selected-item' : '', "\n                ").concat(className ? className : '', "\n            ")
    }, rest, getItemProps({
      item: dropdownItem,
      disabled: dropdownItem.disabled || isChild && !isOpen || dropdownItem.divider || dropdownItem.header,
      index: dropdownIndex,
      ref: function ref(_ref) {
        return menuRef.current = _ref;
      }
    })), dropdownItem.url ? dropdownItem.disabled ? React.createElement("div", {
      className: 'menu-item-content-wrapper'
    }, itemFormatter ? itemFormatter(dropdownItem) : dropdownItem.label) : React.createElement(React.Fragment, null, linkWrapper ? React.cloneElement(linkWrapper({
      item: dropdownItem,
      props: {}
    }), {
      children: checkIfChildIsA(linkWrapper, dropdownItem) ? React.cloneElement((_b = linkWrapper({
        item: dropdownItem,
        props: Object.assign({}, (_a = linkWrapper({
          item: dropdownItem,
          props: {
            children: null
          }
        })) === null || _a === void 0 ? void 0 : _a.props)
      })) === null || _b === void 0 ? void 0 : _b.props.children, {
        children: React.createElement(React.Fragment, null, (_d = linkWrapper({
          item: dropdownItem,
          props: Object.assign({}, (_c = linkWrapper({
            item: dropdownItem,
            props: {
              children: null
            }
          })) === null || _c === void 0 ? void 0 : _c.props)
        })) === null || _d === void 0 ? void 0 : _d.props.children.props.children, dropdownItem.badge && dropdownItem.badge.label !== undefined && !dropdownItem.badge.hidden && React.createElement(NavbarBadge, null, dropdownItem.badge.label))
      }) : React.createElement(React.Fragment, null, ((_e = linkWrapper({
        item: dropdownItem,
        props: {
          children: null
        }
      })) === null || _e === void 0 ? void 0 : _e.props) && ((_f = linkWrapper({
        item: dropdownItem,
        props: {
          children: null
        }
      })) === null || _f === void 0 ? void 0 : _f.props.children) && ((_h = linkWrapper({
        item: dropdownItem,
        props: Object.assign({}, (_g = linkWrapper({
          item: dropdownItem,
          props: {
            children: null
          }
        })) === null || _g === void 0 ? void 0 : _g.props)
      })) === null || _h === void 0 ? void 0 : _h.props.children), dropdownItem.badge && dropdownItem.badge.label !== undefined && !dropdownItem.badge.hidden && React.createElement(NavbarBadge, null, dropdownItem.badge.label))
    }) : React.createElement("a", Object.assign({
      href: dropdownItem.url
    }, getTarget(dropdownItem)), React.createElement(React.Fragment, null, itemFormatter ? itemFormatter(dropdownItem) : itemContent(dropdownItem)))) : React.createElement("div", {
      className: 'menu-item-content-wrapper'
    }, React.createElement(React.Fragment, null, " ", itemFormatter ? itemFormatter(dropdownItem) : itemContent(dropdownItem))));
  };

  useEffect(function () {
    if (menuItem.toggleDropdown !== undefined) {
      setIsOpen(function (prev) {
        return !prev;
      });
    }
  }, [menuItem.toggleDropdown]);
  return React.createElement(React.Fragment, null, menuItem.menuItems ? React.createElement(React.Fragment, null, React.createElement("li", Object.assign({
    className: "\n                            ".concat(menuItem.menuItems ? 'helix-dropdown-menu__overflow-dropdown-item' : '', " \n                            ").concat(index === highlightedIndex ? 'highlighted' : '', "\n                            ").concat(menuItem.disabled ? ' disabled' : '', " \n                            ").concat(className ? className : '')
  }, rest, getItemProps({
    item: menuItem,
    disabled: menuItem.disabled,
    index: index
  }), {
    onClick: function onClick() {
      return setIsOpen(function (prev) {
        return !prev;
      });
    }
  }), React.createElement("div", {
    className: 'menu-item-content-wrapper'
  }, React.createElement("span", {
    className: 'menu-item-label'
  }, menuItem.url && !menuItem.disabled ? React.createElement(React.Fragment, null, linkWrapper && menuItem == undefined ? linkWrapper({
    item: menuItem
  }) : React.createElement("a", {
    href: menuItem.url
  }, formatMenuItem())) : formatMenuItem()), React.createElement(NavbarHelixIcon, {
    iconName: isOpen ? 'dropdown_open' : 'dropdown_closed'
  }))), menuItem.menuItems.map(function (dropdownItem, dropdownIndex) {
    return renderDropdownItem(dropdownItem, index + dropdownIndex + 1, true);
  })) : renderDropdownItem(menuItem, index));
};

export { NavbarMenuItem as default };